import React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

const DownloadBanner = () => {
    const { t } = useTranslation();

    const downloadUrl = "https://thebetteryou.bg/api/v1/qr-download";

    return (
        <section id="cta-banner" className="py-5 bg-white">
            <div className="container">
                <div className="cta-gradient-card text-white rounded-4 p-4 p-sm-5 shadow-lg relative overflow-hidden">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-8">
                            <span className="badge bg-white-20 text-purple-100 text-uppercase fw-bold px-3 py-1.5 rounded-pill mb-3 d-inline-block">
                                {t('Ready to begin?') || 'Ready to begin?'}
                            </span>
                            <h2 className="hero-title mb-3">
                                {t('Start your self-growth journey today.') || 'Start your self-growth journey today.'}
                            </h2>
                            <p className="hero-subtitle text-purple-100 lead mb-4 w-100 w-md-75">
                                Download TheBetterYou now on iOS and Android. Start understanding yourself on a deeper level and achieve real mental clarity.
                            </p>
                            <div className="download-buttons row d-flex justify-content-between align-items-center">
                                <div className="col">
                                    <a href="https://apps.apple.com/bg/app/thebetteryou/id6502434628" target="_blank" rel="noopener noreferrer">
                                        <img alt="apple download thebetteryou" src="/apple_store_download.jpg" className="img-fluid" />
                                    </a>
                                </div>
                                <div className="col">
                                    <a href="https://play.google.com/store/apps/details?id=com.thebetteryoumobile" target="_blank" rel="noopener noreferrer">
                                        <img alt="google download thebetteryou" src="/play_store_download.jpg" className="img-fluid" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 d-flex justify-content-center justify-content-lg-end">
                            <div className="qr-box bg-white p-3 rounded-4 text-center text-dark shadow">
                                <div className="qr-placeholder bg-dark rounded-3 p-2 mx-auto d-flex align-items-center justify-content-center" style={{ width: '130px', height: '130px' }}>
                                    {/* Generated Dynamic QR Code */}
                                    <QRCodeSVG 
                                        value={downloadUrl} 
                                        size={114}
                                        fgColor="#6200a9" // Brand Purple matching your design
                                        bgColor="#FFFFFF"
                                        level="M"
                                    />
                                </div>
                                <p className="mt-2 mb-0 fw-bold small text-dark">{t('Scan to Install') || 'Scan to Install'}</p>
                                <span className="text-muted extra-small">iOS • Android</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DownloadBanner;